import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Activity } from 'lucide-react';
export function ScienceSection() {
  return <section className="w-full py-24 px-4 bg-[#111111] relative overflow-hidden" data-id="element-176">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-gray-900 to-transparent opacity-20 pointer-events-none" data-id="element-177" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-179">
          <div className="space-y-6" data-id="element-180">
            <div className="flex items-center gap-2 text-accent mb-2" data-id="element-181">
              <Activity className="w-5 h-5" data-id="element-182" />
              <span className="text-sm font-bold tracking-widest uppercase" data-id="element-183">
                The Mechanism
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-184">
              THE SCIENCE: <br data-id="element-185" />
              <span className="text-gray-500" data-id="element-186">
                Why Your Current Diet is Failing
              </span>
            </h2>

            <div className="w-20 h-1 bg-accent rounded-full" data-id="element-187" />

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-188">
              At 50+, your margin for error is gone. It’s a{' '}
              <span className="text-white font-bold" data-id="element-189">Timing</span> problem.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-190">
              You are letting glucose float in your bloodstream for too long,{' '}
              <span className="text-accent font-bold" data-id="element-191">"caramelizing"</span> your
              arteries before your muscles claim it.
            </p>

            <p className="text-lg text-gray-300 font-medium pt-4" data-id="element-192">
              We stop the "float" using three non-negotiable intercepted
              strikes:
            </p>
          </div>

          <div className="relative" data-id="element-193">
            {/* Visual representation of "Float Time" */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-8 relative overflow-hidden" data-id="element-194">
              <div className="absolute top-4 right-4 text-gray-700" data-id="element-195">
                <Clock className="w-12 h-12 opacity-20" data-id="element-196" />
              </div>

              <h3 className="text-xl font-bold text-white mb-6 uppercase" data-id="element-197">
                The "Float Time" Danger
              </h3>

              <div className="space-y-6" data-id="element-198">
                <div className="space-y-2" data-id="element-199">
                  <div className="flex justify-between text-sm text-gray-400 uppercase tracking-wider" data-id="element-200">
                    <span data-id="element-201">Normal Clearance</span>
                    <span className="text-green-500" data-id="element-202">Safe Zone</span>
                  </div>
                  <div className="h-3 bg-gray-800 rounded-full overflow-hidden" data-id="element-203">
                    <div className="h-full w-1/3 bg-green-500 rounded-full" data-id="element-204" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-205">
                  <div className="flex justify-between text-sm text-gray-400 uppercase tracking-wider" data-id="element-206">
                    <span data-id="element-207">Your Current Clearance</span>
                    <span className="text-red-500" data-id="element-208">Danger Zone</span>
                  </div>
                  <div className="h-3 bg-gray-800 rounded-full overflow-hidden relative" data-id="element-209">
                    <div className="h-full w-3/4 bg-red-500 rounded-full" data-id="element-210" />
                    {/* Warning indicator */}
                    <div className="absolute top-0 right-[25%] h-full w-px bg-white animate-pulse" data-id="element-211" />
                  </div>
                  <p className="text-xs text-red-400 mt-1 font-mono" data-id="element-212">
                    WARNING: Prolonged exposure causes arterial damage
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}